import CurrencyTooltip from "../../components/currencytooltip/CurrencyTooltip";
import UtilHelper from "../../utils/UtilHelper";
import "./payment.css";
interface PaymentSummaryTotalAmountProps {
  amount: string
  label: string
}

export default function PaymentSummaryTotalAmount({ amount, label}: PaymentSummaryTotalAmountProps) {
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
  
  return (
    <div className="payment-summary-container">
      <div className="payment-row">
        <span className="payment-label">{label}</span>
        <div className="dotted-line"></div>
        <CurrencyTooltip
          content={UtilHelper.CurrencyFormat(numericAmount, false)}
          formatted={UtilHelper.formatCurrency(numericAmount, false)}
        >
          <span className="payment-amount">{UtilHelper.formatCurrency(numericAmount, false)}</span>
        </CurrencyTooltip>
      </div>
    </div>
  )
}